import styles from './ProductImage.module.scss';

import defaultImage from '@/assets/img/no_image.png';
import { imageLink } from '@/shared/lib';

interface ProductImageProps {
  src?: string | null;
  onClick?: () => void;
  quantity?: number;
  className?: string;
}

export const ProductImage = ({
  src,
  onClick,
  quantity,
  className,
}: ProductImageProps) => {
  const imgSrc = src ? imageLink(src) : defaultImage;

  return (
    <div
      className={`${styles.imageWrapper} ${className ?? ''}`}
      onClick={onClick}
    >
      <img src={imgSrc} className={styles.image} alt="default" />
      {!!quantity && <div className={styles.added}>в корзине</div>}
    </div>
  );
};
